import React from "react";
import ArrowRotateClockwiseIcon from "@src/lib/icons/18px/arrow-rotate-clockwise";
import CircleExclamationFillIcon from "@src/lib/icons/18px/circle-exclamation-fill";
import Banner from "@src/lib/ui/Banner";
import { Button } from "@src/lib/ui/Button";
import { cn } from "@src/lib/utils/cn";

interface OpusAgentErrorBubbleProps {
  message?: string;
  onRetry?: () => void;
  retryLabel?: string;
  className?: string;
}

// An error Banner with the retry under the message, so the message keeps the
// full width of the 320px panel instead of wrapping beside the button.
export const OpusAgentErrorBubble: React.FC<OpusAgentErrorBubbleProps> = ({
  message,
  onRetry,
  retryLabel = "Try again",
  className = "",
}) => {
  return (
    <div className={cn("my-2 w-full", className)}>
      <Banner Icon={CircleExclamationFillIcon} className="rounded-xl">
        <p>
          {message ||
            "Something went wrong with the AI response. Please try again."}
        </p>
        {onRetry && (
          <Button
            variant="outline"
            size="sm"
            onClick={onRetry}
            className="mt-2"
          >
            <ArrowRotateClockwiseIcon data-icon="inline-start" />
            {retryLabel}
          </Button>
        )}
      </Banner>
    </div>
  );
};
